var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content tab-voyage" }, [
    _c("div", { staticClass: "grid-view" }, [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showMainList,
              expression: "showMainList"
            }
          ],
          staticClass: "main-content",
          attrs: { type: "primary" }
        },
        [
          _c(
            "div",
            {
              staticClass: "cargo-advance-search",
              staticStyle: {
                height: "auto",
                width: "100%",
                "margin-top": "5px"
              }
            },
            [
              _c(
                "div",
                { staticClass: "section cargo-advance-search-more" },
                [
                  _c(
                    "el-form",
                    {
                      staticClass: "cargo-advance-search-form",
                      staticStyle: {
                        "min-width": "830px",
                        "margin-right": "10px"
                      },
                      attrs: {
                        "label-position": "left",
                        "label-width": _vm.$selectByLang(
                          "80px",
                          "80px",
                          "80px",
                          "120px",
                          "120px",
                          "120px"
                        ),
                        inline: true
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.Vessel") } },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "200px" },
                            attrs: {
                              disabled: _vm.isEdit,
                              filterable: "",
                              clearable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Vessel,
                              "tag-name": "englishName",
                              "tag-value": "vesselId",
                              "default-value": _vm.filter.vesselId,
                              no: "1"
                            },
                            on: { parentCallBack: _vm.vesselChange }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "div",
            {
              staticStyle: { width: "100%", height: "100%", overflow: "hidden" }
            },
            [
              _c(
                "div",
                {
                  staticClass: "section grid-wrapper",
                  staticStyle: { float: "left", height: "100%", width: "30%" }
                },
                [
                  _c("cargo-ag-grid", {
                    attrs: {
                      "grid-params": _vm.voyage.gridParams,
                      "grid-options": _vm.voyage.gridOptions,
                      "column-defs": _vm.voyageColumnDefs,
                      "show-side-bar": false,
                      "row-data": _vm.voyage.rowData
                    },
                    on: {
                      "update:gridParams": function($event) {
                        return _vm.$set(_vm.voyage, "gridParams", $event)
                      },
                      "update:grid-params": function($event) {
                        return _vm.$set(_vm.voyage, "gridParams", $event)
                      },
                      gridReady: function(params) {
                        _vm.voyage.gridOptions.gridApi = params.api
                      }
                    }
                  }),
                  _c(
                    "div",
                    { staticClass: "app-main-inner-row row-pagination" },
                    [
                      _c("cargo-pagination", {
                        attrs: {
                          "config-module": "3106888",
                          total: _vm.filter.total,
                          page: _vm.filter.pageNum,
                          limit: _vm.filter.pageSize
                        },
                        on: {
                          "update:page": function($event) {
                            return _vm.$set(_vm.filter, "pageNum", $event)
                          },
                          "update:limit": function($event) {
                            return _vm.$set(_vm.filter, "pageSize", $event)
                          },
                          pagination: _vm.toQuery
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: { margin: "0", padding: "0", width: "100%" }
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { float: "right", margin: "10px" } },
                        [
                          _c(
                            "el-checkbox",
                            {
                              staticStyle: { "margin-left": "-20px" },
                              attrs: { no: "virtualHBL" },
                              model: {
                                value: _vm.copyShip,
                                callback: function($$v) {
                                  _vm.copyShip = $$v
                                },
                                expression: "copyShip"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.CopyShip")))]
                          ),
                          !_vm.isEdit
                            ? _c(
                                "el-button",
                                {
                                  staticStyle: {
                                    "margin-left": "10px",
                                    width: "60px"
                                  },
                                  attrs: {
                                    disabled: !_vm.filter.vesselId,
                                    type: "primary",
                                    no: "2"
                                  },
                                  on: { click: _vm.onAddVoyage }
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("SeaExport.Add")) + " "
                                  )
                                ]
                              )
                            : _vm._e(),
                          !_vm.isEdit
                            ? _c(
                                "el-button",
                                {
                                  staticStyle: {
                                    "margin-left": "10px",
                                    width: "60px"
                                  },
                                  attrs: {
                                    type: "primary",
                                    disabled: !_vm.hasChooseVoyage,
                                    no: "3"
                                  },
                                  on: { click: _vm.onEditVoyage }
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("SeaExport.Edit")) + " "
                                  )
                                ]
                              )
                            : _vm._e(),
                          !_vm.isEdit
                            ? _c(
                                "el-button",
                                {
                                  staticStyle: {
                                    "margin-left": "10px",
                                    width: "60px"
                                  },
                                  attrs: {
                                    type: "danger",
                                    disabled: !_vm.hasChooseVoyage,
                                    no: "4"
                                  },
                                  on: { click: _vm.onRemoveVoyage }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("SeaExport.Delete")) +
                                      " "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.isEdit
                            ? _c(
                                "el-button",
                                {
                                  staticStyle: {
                                    "margin-left": "10px",
                                    width: "60px"
                                  },
                                  attrs: { type: "primary", no: "5" },
                                  on: { click: _vm.onSaveVoyage }
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("SeaExport.Save")) + " "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.isEdit
                            ? _c(
                                "el-button",
                                {
                                  staticStyle: {
                                    "margin-left": "10px",
                                    width: "60px"
                                  },
                                  attrs: { type: "primary", no: "6" },
                                  on: { click: _vm.onCancelVoyage }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("SeaExport.Cancel")) +
                                      " "
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "section grid-wrapper",
                  staticStyle: { float: "right", height: "100%", width: "69%" }
                },
                [
                  _c("cargo-ag-grid", {
                    attrs: {
                      "grid-params": _vm.segment.gridParams,
                      "grid-options": _vm.segment.gridOptions,
                      "column-defs": _vm.segmentColumnDefs,
                      "show-side-bar": false,
                      "row-data": _vm.segment.rowData
                    },
                    on: {
                      "update:gridParams": function($event) {
                        return _vm.$set(_vm.segment, "gridParams", $event)
                      },
                      "update:grid-params": function($event) {
                        return _vm.$set(_vm.segment, "gridParams", $event)
                      },
                      gridReady: function(params) {
                        _vm.segment.gridOptions.gridApi = params.api
                      }
                    }
                  }),
                  _vm.isEdit
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            margin: "0",
                            padding: "0",
                            width: "100%"
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { float: "right", margin: "10px" } },
                            [
                              _c(
                                "el-button",
                                {
                                  staticStyle: {
                                    "margin-left": "10px",
                                    width: "60px"
                                  },
                                  attrs: { type: "primary", no: "7" },
                                  on: { click: _vm.onAddSegment }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("SeaExport.IncreaseThePort")
                                      ) +
                                      " "
                                  )
                                ]
                              ),
                              _c(
                                "el-button",
                                {
                                  staticStyle: {
                                    "margin-left": "10px",
                                    width: "60px"
                                  },
                                  attrs: { type: "primary", no: "8" },
                                  on: { click: _vm.onRemoveSegment }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("SeaExport.DeletePorts")) +
                                      " "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }